/**
 * CSP Nonce Initialization
 *
 * This module MUST be imported first in index.jsx to ensure:
 * 1. The nonce is read from the meta tag (injected by Lambda)
 * 2. document.createElement is patched to add nonces to all style tags
 * 3. Emotion speedy mode is disabled globally
 */

// Read nonce from meta tag (Lambda will inject this)
function getCspNonce() {
  if (typeof document === 'undefined') return undefined;
  const el = document.querySelector('meta[name="csp-nonce"]');
  const nonce = el?.getAttribute('content');
  return nonce; //&& nonce !== 'NONCE_PLACEHOLDER' ? nonce : undefined;
}

// Initialize CSP nonce support
const nonce = getCspNonce();
// Set global nonce for external access
window.__nonce__ = nonce;

// Force Emotion to NEVER use speedy mode (critical for CSP)
// Speedy mode uses insertRule() which doesn't respect nonce attributes
window.EMOTION_DISABLE_SPEEDY = true;

// Patch document.createElement to automatically add nonce to all <style> tags
if (nonce) {
  const originalCreateElement = document.createElement.bind(document);
  document.createElement = function(tagName) {
    const element = originalCreateElement(tagName);
    if (tagName.toLowerCase() === 'style') {
      element.setAttribute('nonce', nonce);
    }
    return element;
  };

  console.log('[CSP Init] Nonce:', nonce);
  console.log('[CSP Init] Style injection patched');
  console.log('[CSP Init] Emotion speedy mode disabled');
} else {
  console.warn('[CSP Init] No nonce found - CSP may block styles');
}

export { nonce, getCspNonce };
